<template>
  <v-layout>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col>
          <h1>Welcome to the Admin-Dashboard / Panel</h1>
          <h3>Currently, there aren't any Analytics directly integrated.</h3>
          <h3>
            But as a good User, you could access them from the Google Analytics
            Dashboard
          </h3>
          <a
            href="https://analytics.google.com/analytics/web/?hl=de#/p236879624/reports/home?params=_u..nav%3Dga1-experimental"
            target="_blank"
            >GOOGLE ANALYTICS DASHBOARD</a
          >
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
export default {};
</script>

<style></style>
